import { USER_ACCOUNT_LOADING_STATUS } from "../../modules/ClientAuthorization/Default/common/constant"

import { useClientContext } from "modules/ClientAuthorization/common/ClientContext"

export function useShowPrice() {
    const [{ loading, userAccount }] = useClientContext()

    if (loading !== USER_ACCOUNT_LOADING_STATUS.READY) return false
    if (userAccount.kind === "verified") {
        return userAccount.show_price
    } else {
        return true
    }
}
